import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './AIProcessingWarningModal.css';

const AIProcessingWarningModal = ({ isOpen, onStay, onLeave, processingTypes = [] }) => {
    if (!isOpen) return null;

    // Determine which processes are running
    const hasRiskAnalysis = processingTypes.includes('risk');
    const hasDocumentScanning = processingTypes.includes('document');
    const hasBoth = hasRiskAnalysis && hasDocumentScanning;

    // Build dynamic message
    let processMessage = '';
    if (hasBoth) {
        processMessage = 'Risk analysis and document scanning are currently running.';
    } else if (hasRiskAnalysis) {
        processMessage = 'Risk analysis is currently running.';
    } else if (hasDocumentScanning) {
        processMessage = 'Document scanning is currently running.';
    }

    return (
        <div className="ai-processing-warning-overlay">
            <div className="ai-processing-warning-modal">
                <div className="ai-processing-warning-header">
                    <div className="ai-processing-warning-icon">
                        <FontAwesomeIcon icon={faRobot} />
                    </div>
                    <h2>AI Analysis in Progress</h2>
                </div>
                
                <div className="ai-processing-warning-content">
                    <div className="ai-processing-warning-message">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="warning-icon" />
                        <p>
                            <strong>{processMessage}</strong>
                        </p>
                        <p>
                            If you leave now, the analysis will be stopped and you'll need to restart it.
                        </p>
                    </div>
                    
                    {hasBoth && (
                        <div className="ai-processing-details">
                            <ul>
                                <li>Risk analysis will be cancelled</li>
                                <li>Document scanning will be cancelled</li>
                                <li>All progress will be lost</li>
                            </ul>
                        </div>
                    )}
                </div>
                
                <div className="ai-processing-warning-actions">
                    <button 
                        onClick={onStay}
                        className="ai-processing-stay-button"
                    >
                        <i className="fas fa-check-circle"></i>
                        Stay on Page
                    </button>
                    <button 
                        onClick={onLeave}
                        className="ai-processing-leave-button"
                    >
                        <i className="fas fa-sign-out-alt"></i>
                        Leave and Stop Analysis
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIProcessingWarningModal;
